<template>
  <el-popover
    placement="top-start"
    :title="TipTypeMap[t].title || '提示'"
    :width="TipTypeMap[t].width || 350"
    trigger="hover"
  >
    <div v-html="TipTypeMap[t].content"></div>
    <i
      slot="reference"
      class="el-icon-warning-outline"
      style="position: relative; top: -5px"
    ></i>
  </el-popover>
</template>

<script>
const TipTypeMap = {
  1: {
    title: '客户小程序可见商品包含',
    content: `1、商品分类里设置为小程序展示的商品；<br/>
              2、根据客户设备分类与商品PH对应的商品；<br/>
              3、给客户单独设置的可见PH商品；`,
  },
  2: {
    title: '人员简称用处',
    content: `1、报价单的编号规则包含报价人员简称`,
  },
  3: {
    title: '说明',
    content: `1、若关联该分类的商品没有封面和详情，则引用该分类的封面和详情；<br/>
              2、若该分类无封面和详情，则会继续查找上级分类封面和详情；`,
  },
  4: {
    title: '说明',
    content: `商机潜力值是某设备当前年份需要保养套餐总值`,
  },
  5: {
    title: '说明',
    content: `商机潜力值是某客户名下设备当前年份需要保养套餐总值；<br/>设备的中间商或OEM商或最终客户为该客户的设备都是该客户的统计范围`,
  },
  6: {
    title: '说明',
    content: `若选择是：小程序端用户在服务请求中就能看见该流程信息；若选择否则该流程对用户不可见；`,
  },
  7: {
    title: '说明',
    content: `若选择是：小程序端用户在服务请求的流程进度里就能看见该步骤信息；若选择否则该步骤对用户不可见；`,
  },
  8: {
    title: '说明',
    content: `若选择是：最终客户为该客户的设备所绑定的中间商可以看见该客户和此设备；若选择否则不可见；`,
  },
  9: {
    title: '说明',
    content: `若选择是：最终客户为该客户的设备所绑定的OEM商可以看见该客户和此设备；若选择否则不可见；`,
  },
}
export default {
  props: {
    t: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      TipTypeMap,
    }
  },
}
</script>